<template>
<div>

    <tti-header></tti-header>

    <div class="flex justify-center px-4">
        <div class="prose prose-sm" v-html="policy">
            Loading privacy policy…
        </div>
    </div>

    <tti-footer></tti-footer>

</div>
</template>
<script>

import axios from 'axios'
import MarkdownIt from 'markdown-it'

const md = new MarkdownIt({
    linkify:      true,        // Autoconvert URL-like text to links
    typographer:  true,
    html: true
})

export default {
    components: {
        'tti-header': () => import('./HeaderNew'),
        'tti-footer': () => import('./Footer')
    },
    data() {
        return {
            policy: null
        }
    },
    methods: {
        async loadPolicy() {
            var response = await axios.get('/privacy-policy.md');
            this.policy = md.render(response.data);

            this.$nextTick(() => {
                this.connectVueLinks();
            });
        },
        connectVueLinks() {
            this.$refs.termsBody.addEventListener('click', event => {
                if (event.target.tagName !== 'A')
                return;

                if (event.target && event.target.matches("a:not([href*='://'])") && event.target.matches("a:not([href*='mailto:'])") && event.target.href) {
                    const url = new URL(event.target.href);
                    const to = url.pathname;
                    event.preventDefault();
                    this.$router.push(to);
                }

                // https://stackoverflow.com/questions/62344669/vue-router-creating-a-router-link-with-a
            });
        },
    },
    mounted() {
        this.loadPolicy();
    }
}
</script>